import Link from 'next/link'
import Image from 'next/image'
import cn from 'clsx'
import s from './Post.module.scss'
import React, { FC, useState } from 'react'
import {
  FullHeightSection,
  Text,
  CustomImage,
  Container,
  Button,
} from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'

import { Post } from '@commerce/types/post'

type PostPreviewProps = {
  post: Post
  size: 'small' | 'large'
}

type PostsProps = {
  data: Post[]
  children?: any
}

const PostPreview: FC<PostPreviewProps> = ({ post, size }) => {
  return (
    <>
      {post.url && (
        <div
          className={cn(
            s.previewRoot,
            size == 'large' ? s.previewRootLarge : s.previewRootSmall
          )}
        >
          <Link href={post.url.replace('the-logbook/', '')}>
            <a>
              <div className={s.previewImage}>
                {post.thumbnail_path && (
                  <Image
                    src={post.thumbnail_path}
                    alt={post.title}
                    layout="fill"
                    objectFit="cover"
                  />
                )}
              </div>
              <div className={s.previewContent}>
                <Text variant="smallText" className={s.previewSubject}>
                  {post.meta_keywords}
                </Text>
                <Text
                  variant={size == 'large' ? 'heading' : 'sectionHeading'}
                  className={s.previewTitle}
                >
                  {post.title}
                </Text>
              </div>{' '}
            </a>
          </Link>
        </div>
      )}
    </>
  )
}

const Posts: FC<PostsProps> = ({ data, children }) => {
  const [showMore, setShowMore] = useState(3)

  return (
    <div className={s.root}>
      <div>
        <Text variant="heading" className={s.blogTitle}>
          The Logbook
        </Text>
        <div className={s.postsContainer}>
          {data.map((post, index) => (
            <React.Fragment key={`post-${index}`}>
              {index < showMore && (
                <PostPreview
                  post={post}
                  size={index == 0 ? 'large' : 'small'}
                />
              )}
            </React.Fragment>
          ))}

          {showMore < data.length && (
            <div className={s.viewAllContainer}>
              <Button
                className={s.viewAll}
                onClick={() => setShowMore(showMore + 3)}
              >
                Read More
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Posts
